import { takeEvery, put, all } from 'redux-saga/effects';

import apiFetcher from '../../tools/api-fetcher';
import handleError from '../../tools/error-helper';

import * as types from '../../actions/school-candidate/school-candidate-partner/types';
import * as actions from '../../actions/school-candidate/school-candidate-partner';

function* getSchoolCandidatePartnerProfileDetails(schoolId, candidateId, loadingAction, mainAction, infoTypeUrlPart) {
  yield put(loadingAction(true));
   try {
    const { data } = yield apiFetcher.auth().get(`/schools/${schoolId}/candidates/${candidateId}/partner/profile/${infoTypeUrlPart}`);

    yield put(mainAction(data));
  } catch (exception) {
    handleError(exception);
  }
  yield put(loadingAction(false));
}

function* getSchoolCandidatePartnerHealth({ schoolId, candidateId }) {
  yield getSchoolCandidatePartnerProfileDetails(
    schoolId, 
    candidateId,
    actions.setSchoolCandidatePartnerProfileHealthLoading,
    actions.setSchoolCandidatePartnerProfileHealth,
    'health');
}

function* getSchoolCandidatePartnerBiographicalInfo({ schoolId, candidateId }) {
  yield getSchoolCandidatePartnerProfileDetails(
    schoolId,
    candidateId,
    actions.setSchoolCandidatePartnerProfileBiographicalInformationLoading,
    actions.setSchoolCandidatePartnerProfileBiographicalInformation,
    'biographical-information');
}

function* getSchoolCandidatePartnerPersonal({ schoolId, candidateId }) {
  yield getSchoolCandidatePartnerProfileDetails(
    schoolId, 
    candidateId,
    actions.setSchoolCandidatePartnerProfilePersonalLoading,
    actions.setSchoolCandidatePartnerProfilePersonal,
    'personal');
}

function* getSchoolCandidatePartnerContactInformation({ schoolId, candidateId }) {
  yield getSchoolCandidatePartnerProfileDetails(
    schoolId, 
    candidateId,
    actions.setSchoolCandidatePartnerProfileContactInformationLoading,
    actions.setSchoolCandidatePartnerProfileContactInformation,
    'contact-information');
}

function* getSchoolCandidatePartnerSportsActivities({ schoolId, candidateId }) {
  yield getSchoolCandidatePartnerProfileDetails(
    schoolId, 
    candidateId,
    actions.setSchoolCandidatePartnerProfileSportActivitiesLoading,
    actions.setSchoolCandidatePartnerProfileSportActivities,
    'sports-and-activities');
}

function* getSchoolCandidatePartnerSecondarySchools({ schoolId, candidateId }) {
  yield getSchoolCandidatePartnerProfileDetails(
    schoolId, 
    candidateId,
    actions.setSchoolCandidatePartnerProfileSecondarySchoolsLoading,
    actions.setSchoolCandidatePartnerProfileSecondarySchools,
    'secondary-schools');
}

function* getSchoolCandidatePartnerUniversitiesColleges({ schoolId, candidateId }) {
  yield getSchoolCandidatePartnerProfileDetails(
    schoolId, 
    candidateId,
    actions.setSchoolCandidatePartnerProfileUniversitiesCollegesLoading,
    actions.setSchoolCandidatePartnerProfileUniversitiesColleges,
    'higher-educations');
}

function* getSchoolCandidatePartnerHousingPreferences({ schoolId, candidateId }) {
  yield getSchoolCandidatePartnerProfileDetails(
    schoolId, 
    candidateId,
    actions.setSchoolCandidatePartnerProfileHousingPreferencesLoading,
    actions.setSchoolCandidatePartnerProfileHousingPreferences,
    'housing-preferences');
}

function* getSchoolCandidatePartnerLanguages({ schoolId, candidateId }) {
  yield getSchoolCandidatePartnerProfileDetails(
    schoolId, 
    candidateId,
    actions.setSchoolCandidatePartnerProfileLanguagesLoading,
    actions.setSchoolCandidatePartnerProfileLanguages,
    'languages');
}

function* getSchoolCandidatePartnerTeachingCredentials({ schoolId, candidateId }) {
  yield getSchoolCandidatePartnerProfileDetails(
    schoolId, 
    candidateId,
    actions.setSchoolCandidatePartnerProfileTeachingCredentialsLoading,
    actions.setSchoolCandidatePartnerProfileTeachingCredentials,
    'teaching-credentials');
}

function* getSchoolCandidatePartnerTeachingExperience({ schoolId, candidateId }) {
  yield getSchoolCandidatePartnerProfileDetails(
    schoolId, 
    candidateId,
    actions.setSchoolCandidatePartnerProfileTeachingExperienceLoading,
    actions.setSchoolCandidatePartnerProfileTeachingExperience,
    'teaching-experience');
}

function* getSchoolCandidatePartnerDocuments({ schoolId, candidateId }) {
  yield getSchoolCandidatePartnerProfileDetails(
    schoolId, 
    candidateId,
    actions.setSchoolCandidatePartnerProfileDocumentsLoading,
    actions.setSchoolCandidatePartnerProfileDocuments,
    'documents/summaries');
}

export default function* schoolCandidatePartnerSaga() {
  yield all([
    takeEvery(types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_BIOGRAPHICAL_INFORMATION, getSchoolCandidatePartnerBiographicalInfo),
    takeEvery(types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_CONTACT_INFORMATION, getSchoolCandidatePartnerContactInformation),
    takeEvery(types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_HEALTH, getSchoolCandidatePartnerHealth),
    takeEvery(types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_HOUSING_PREFERENCES, getSchoolCandidatePartnerHousingPreferences),
    takeEvery(types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_LANGUAGES, getSchoolCandidatePartnerLanguages),
    takeEvery(types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_PERSONAL, getSchoolCandidatePartnerPersonal),
    takeEvery(types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_SECONDARY_SCHOOLS, getSchoolCandidatePartnerSecondarySchools),
    takeEvery(types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_SPORT_ACTIVITIES, getSchoolCandidatePartnerSportsActivities),
    takeEvery(types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_TEACHING_CREDENTIALS, getSchoolCandidatePartnerTeachingCredentials),
    takeEvery(types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_TEACHING_EXPERIENCE, getSchoolCandidatePartnerTeachingExperience),
    takeEvery(types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_UNIVERSITIES_COLLEGES, getSchoolCandidatePartnerUniversitiesColleges),
    takeEvery(types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_DOCUMENTS, getSchoolCandidatePartnerDocuments)
  ]);}


// WEBPACK FOOTER //
// ./src/sagas/school/school-candidate-partner.js